<template>
    <div class="container-main-body">
      <!--按钮开始-->
      <div class="list-container">
        <div v-if="searchShow" class="search-container">
          <el-row>
            <el-col :span="6">
              <div class="search-form-label">部门：</div>
              <div class="search-form-controller">
                <el-input
                  size="mini"
                  placeholder="部门"
                  clearable
                  v-model="queryData.department_name"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="search-form-label">样本册：</div>
              <div class="search-form-controller">
                <el-input
                  size="mini"
                  placeholder="样本册"
                  clearable
                  v-model="queryData.product_name"
                ></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="text-align: center;">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-search"
                plain
                @click="searchHandler"
                >开始搜索</el-button
              >
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-delete"
                plain
                @click="searchHandler('clear')"
                >清空</el-button
              >
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-close"
                plain
                @click="showSearchHandler()"
                >关闭搜索</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="list-btns-container">
          <el-button-group>
            <el-button
              v-for="btn in $store.state.currentLBtnList"
              :key="btn.id"
              :type="btn.button_type"
              size="mini"
              :icon="btn.button_icon"
              @click="handlerButtonDispatch(btn.fn)"
              >{{ btn.button_name }}</el-button
            >
          </el-button-group>
        </div>
        <!--按钮结束-->
        <!--列表数据 开始-->
        <div class="el-table-container">
          <el-table
            :data="ds"
            size="mini"
            stripe
            border
            height="100%"
            style="width: 100% border:1px solid #d1d1d1"
            header-row-class-name="list-header-row"
            row-class-name="list-row"
          >
            <el-table-column label="状态" width="150" align="center">
              <template slot-scope="scope">
                {{scope.row.scanCount === 0 ? '未扫描' : '已扫描'}}
              </template>
            </el-table-column>
            <el-table-column
              label="标记"
              prop="mark"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              label="样本册"
              prop="product_name"
              width="170"
              align="center"
            ></el-table-column>
            <el-table-column
              label="类型"
              prop="transport_type"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              label="笼号"
              prop="basketNo"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              label="托盘种类"
              prop="pallet_type"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              label="箱子数量"
              prop="plan_box_num"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              label="部门"
              prop="department_name"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="样本册分期"
              prop="product_phase"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="返库分期"
              prop="phase"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="丁合机分区"
              prop="district"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="创建人"
              prop="creater_name"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              prop="create_time"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column></el-table-column>
            <el-table-column label="打印" width="60" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-printer"
                  circle
                  plain
                  @click.stop.prevent="printHandler(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-view"
                  circle
                  plain
                  @click.stop.prevent="viewHandler(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column label="删除" width="60" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  :disabled="scope.row.creater_id!=currentOperateId"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete-solid"
                  circle
                  plain
                  @click.stop.prevent="deleteHandler(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <el-pagination
            background
            :current-page="queryData.pn"
            :page-size="queryData.pageSize"
            :total="queryData.totalCount"
            :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChange"
            @current-change="pageChange"
          ></el-pagination>
        </div>
      </div>
      <!--列表数据 结束-->
      <!-- 新增表单对话框 -->
      <out-store-note-form ref="DForm" :parent="this" />
      
      <div id="print_area" style="position: relative; z-index: -1;text-align:center">
        <div style="font-size:40pt">外库票</div>
        <div ref="codeItem" style="margin-top:20px"></div>
        <div style="display:flex;flex-direction: row;justify-content: space-between;font-size:30pt;margin-top:40px;width:80%;margin-left:10%">
          <div>{{printProduct}}</div>
          <div>
            <span v-for="pg in printPageList" :key="pg.id">{{pg.page+'页'}}</span>
          </div>
        </div>
        <div style="display:flex;flex-direction: row;justify-content: space-between;font-size:30pt;margin-top:40px;width:80%;margin-left:10%">
          <div>{{printdistrict+'区'}}</div>
          <div>{{printPhase+'期'}}</div>
        </div>
        <div style="display:flex;flex-direction: row;justify-content: space-between;font-size:30pt;margin-top:40px;width:80%;margin-left:10%">
          <div>{{printProductType}}</div>
          <div>{{printProductPhase}}</div>
        </div>
        <!-- <div style="margin-top:10px;font-size:40pt;font-weight: bold;">
          <span>样本册：</span><span>{{printProduct}}</span>
        </div>
        <div style="margin-top:10px;font-size:40pt;font-weight: bold;">
          <span>分期：</span><span>{{printPhase}}</span>
        </div>
        <div style="margin-top:10px;font-size:40pt;font-weight: bold;">
          <span>丁合机分区：</span><span>{{printdistrict}}</span>
        </div>
        <div style="margin-top:10px;font-size:35pt;font-weight: bold;">
          <span>部门：</span><span>{{printDepartment}}</span><span style="margin-left:10px">|</span><span style="margin-left:10px">类型：</span><span >{{printType}}</span>
        </div>
        <div style="margin-top:10px;font-size:35pt;font-weight: bold;">
          <span >标记：</span><span >{{printMark}}</span>
        </div>
        <div style="margin-top:10px;font-size:35pt;font-weight: bold;">
          <span >箱子数量：</span><span >{{printBoxNum}}</span>
        </div>
        <div v-for="pg in printPageList" :key="pg.id" style="margin-top:10px;font-size:35pt;font-weight: bold;">
          <span>页码：{{pg.page}}</span><span style="margin-left: 10px;margin-right: 10px;">|</span><span>箱数：{{pg.box_no}}</span>
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  import QRCode from 'qrcodejs2'
  import OutStoreNoteForm from "@/views/modules/outstore/outstorenote/Form";
  export default {
    data: function() {
      return {
        ds: [],
        queryData: {
          department_name: "",
          product_name: "",
          pn: 1, // 页码
          pageSize: 20, // 每页条数
          totalCount: 0, // 数据总条数
          currentDepart:''
        },
        searchShow: false,
        printProduct: '',
        printPhase: '',
        printProductPhase:'',
        printdistrict: '',
        printType: '',
        printDepartment:'',
        printBoxNum:'',
        printMark:'',
        printPageList: [],
        printProductType:'',
        // by dream 2024-03-07 20:59:00 增加删除按钮的操作权限
        currentOperateId:sessionStorage.getItem("operator_id"),
      };
    },
    created: function() {},
    mounted: function() {
      this.loadDepartment();
    },
    methods: {
      // 按钮 点击 调度方法
      handlerButtonDispatch: function(fn, args) {
        var _this = this;
        if (typeof _this[fn] === "function") {
          _this[fn].apply(_this, args);
        } else {
          console.log("warning: the method is not exist");
        }
      },
      // 加载数据
      loadData: function() {
        let _this = this;
        _this.post(_this.$apis.getPalletList, this.queryData, function(
          res
        ) {
          let _json = res.data;
          if (_json.status && _json.status === "logout") {
            _this.logout();
          } else {
            _this.ds = _json.datalist;
            _this.queryData.totalCount = _json.totalCount;
          }
        });
      },
      // 新增
      addHandler: function() {
        this.$refs.DForm.addHandler();
      },
      // 浏览
      viewHandler: function(_row) {
        let formId = _row.id;
        this.$refs.DForm.viewHandler(formId);
      },
      //删除
      deleteHandler: function(_row){
        let _this = this;
        _this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              let _params = {id: _row.id};
              // ajax提交至服务器，删除数据
              _this.post(_this.$apis.delPalletModelList, _params, function(res) {
                let _json = res.data;
                if (_json.status === "ok") {
                  _this.loadData();
                  _this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                } else {
                  _this.$message({
                    type: "error",
                    message: "已入库，不允许删除!"
                  });
                }
              });
            }).catch(() => {
              _this.$message({
                type: "info",
                message: "已取消删除"
              });
            });
      },
      searchHandler: function(_type) {
        this.queryData.pn = 1;
        if (_type === "clear") {
          this.queryData.department_name = "";
          this.queryData.product_name = "";
        }
        this.loadData();
      },
      showSearchHandler: function() {
        this.searchShow = !this.searchShow;
      },
      // 刷新事件
      refreshHandler: function() {
        this.loadData();
      },
      // 页码改变
      pageSizeChange: function(pageSize) {
        this.queryData.pn = 1;
        this.queryData.pageSize = pageSize;
        this.loadData();
      },
      pageChange: function(pn) {
        this.queryData.pn = pn;
        this.loadData();
      },
      printHandler: function (row) {
        let _this = this
        _this.$refs.codeItem.innerHTML = ''
        _this.printProduct = row.product_name
        _this.printPhase = row.phase
        _this.printProductPhase = row.product_phase
        _this.printdistrict = row.district
        _this.printType = row.transport_type
        _this.printDepartment = row.department_name
        _this.printBoxNum = row.plan_box_num
        _this.printMark = row.mark
        _this.printProductType = row.product_type
        new QRCode(_this.$refs.codeItem, {
          // 二维码内容
          text: row.id,
          width: 400,
          height: 400,
          // 二维码颜色
          colorDark: '#333333',
          // 二维码背景色
          colorLight: '#ffffff'
        })

        _this.printPageList = [];
        if(row.department_name === '粘贴') {
          _this.post(_this.$apis.getPageList, {id:row.id}, function(res) {
            let _json = res.data;
            _this.printPageList = _json.pagelist;
          });
        }
        
        setTimeout(() => {
          const style =
            '@page { margin-top: 50px } @media print { h1 { color: blue } img {margin: 0 auto;}}'
          _this.$print({
            printable: 'print_area',
            type: 'html',
            style: style,
            scanStyles: false
          })
        }, 200)
      },
      loadDepartment: function () {
        const _this = this
        _this.post(_this.$apis.getDepartmentList, {userId:sessionStorage.getItem("operator_id")}, function (res) {
          const _json = res.data
          _this.queryData.currentDepart = _json.departments[0].name
          _this.queryData.department_name = _json.departments[0].name
          _this.loadData();
        })
      },
      // 导出excel
      exportHandler: function() {
        let _this = this;
        _this.post(
          _this.$apis.exportOutNoteList,
          _this.queryData,
          function(res) {
            let _json = res.data;
            if (_json.fileUrl !== "") {
              if(_json.fileUrl.indexOf('&') > 0) {
                window.location = _this.$apiroot + _json.fileUrl.split('&')[0];
                window.location = _this.$apiroot + _json.fileUrl.split('&')[1];
              } else {
                window.location = _this.$apiroot + _json.fileUrl;
              }
            } else {
              _this.$router.push({
                path: "/"
              });
            }
          }
        );
      }
    },
    components: {
        OutStoreNoteForm
    }
  };
  </script>
  